import { api, RTKTags } from '@/store/api'

import Env from '../../../env/env'

import type {
  CreatePersonaInquiryRequest,
  PersonaInquiryResponse,
  ResumePersonaInquiryRequest,
  ResumePersonaInquiryResponse,
} from './Persona.types'

export const personaApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createPersonaInquiry: builder.mutation<
      PersonaInquiryResponse,
      CreatePersonaInquiryRequest
    >({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/persona/inquiry`,
        method: 'POST',
        body: request,
      }),
      invalidatesTags: [RTKTags.persona],
    }),
    resumePersonaInquiry: builder.mutation<
      ResumePersonaInquiryResponse,
      ResumePersonaInquiryRequest
    >({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/persona/resume`,
        method: 'POST',
        body: request,
      }),
      invalidatesTags: [RTKTags.persona],
    }),
  }),
})

export const {
  useCreatePersonaInquiryMutation,
  useResumePersonaInquiryMutation,
} = personaApi
